import { useQuery } from "@tanstack/react-query";
import { getLoyaltyPoints } from "../admin/loyalty/loyaltyApi";

const loyaltyPointsKey = "loyalty-points";

export const useLoyaltyPoints = (enabled: boolean) => {
  const { data, isLoading } = useQuery({
    queryKey: [loyaltyPointsKey],
    queryFn: ({ signal }) => getLoyaltyPoints(signal),
    staleTime: 0,
    enabled,
  });

  return {
    loyaltyPoints: data,
    isLoading,
  };
};
